// Historical Photo Archive — shared i18n strings for hub, island, and
// detail pages. Keys are grouped locally in this file (rather than
// added to i18n.js) so future translators can review the whole
// history-surface vocabulary in one place. Every key must ship all
// five languages — the app's audit fails the build on English fallback.

export const HISTORY_UI = {
  hub_title: {
    en: "Caribbean Historical Photo Archive",
    es: "Archivo Fotográfico Histórico del Caribe",
    nl: "Caribisch Historisch Fotoarchief",
    pap: "Archivo Fotográfiko Históriko di Karibe",
    pap_aw: "Archivo Fotografico Historico di Caribe",
  },
  hub_intro: {
    en: "Public-domain and Creative Commons photography from Aruba and Curaçao, sourced from Wikimedia Commons and museum collections. Every photo carries its original attribution and license — click through for full metadata and the source page.",
    es: "Fotografía de dominio público y Creative Commons de Aruba y Curazao, obtenida de Wikimedia Commons y colecciones de museos. Cada foto lleva su atribución y licencia originales; pulsa para ver los metadatos completos y la página de origen.",
    nl: "Publiek-domein en Creative Commons fotografie uit Aruba en Curaçao, afkomstig van Wikimedia Commons en museumcollecties. Elke foto draagt haar originele bronvermelding en licentie — klik door voor volledige metadata en de bronpagina.",
    pap: "Fotografia di dominio públiko i Creative Commons di Aruba i Kòrsou, ku ta bini di Wikimedia Commons i koleksionnan di museo. Kada foto ta karga su atribushon i lisensia orginal — klik pa mira metadatanan kompleto i e página di fuente.",
    pap_aw: "Fotografia di dominio publico y Creative Commons di Aruba y Corsou, cu ta bini di Wikimedia Commons y colecionnan di museo. Cada foto ta carga su atribucion y licencia original — click pa wak metadatanan completo y e pagina di fuente.",
  },
  island_page_title: {
    en: "%s — Historical Photos",
    es: "%s — Fotos Históricas",
    nl: "%s — Historische Foto's",
    pap: "%s — Fotonan Históriko",
    pap_aw: "%s — Fotonan Historico",
  },
  filter_all_decades: {
    en: "All decades", es: "Todas las décadas", nl: "Alle decennia",
    pap: "Tur década",  pap_aw: "Tur decada",
  },
  filter_decade: {
    en: "%ss", es: "Años %s", nl: "Jaren %s",
    pap: "Añanan %s", pap_aw: "Añanan %s",
  },
  no_photos_yet: {
    en: "No photos published yet. Backfill runs overnight.",
    es: "Aún no hay fotos publicadas. La sincronización se ejecuta durante la noche.",
    nl: "Nog geen foto's gepubliceerd. De backfill draait 's nachts.",
    pap: "Ainda no tin foto publiká. E backfill ta kore durante anochi.",
    pap_aw: "Ainda no tin foto publica. E backfill ta core durante anochi.",
  },
  meta_photographer: {
    en: "Photographer", es: "Fotógrafo", nl: "Fotograaf",
    pap: "Fotógrafo", pap_aw: "Fotografo",
  },
  meta_date: {
    en: "Date", es: "Fecha", nl: "Datum", pap: "Fecha", pap_aw: "Fecha",
  },
  meta_license: {
    en: "License", es: "Licencia", nl: "Licentie",
    pap: "Lisensia", pap_aw: "Licencia",
  },
  meta_source: {
    en: "Source", es: "Fuente", nl: "Bron",
    pap: "Fuente", pap_aw: "Fuente",
  },
  meta_dimensions: {
    en: "Dimensions", es: "Dimensiones", nl: "Afmetingen",
    pap: "Tamaño", pap_aw: "Tamaño",
  },
  view_on_commons: {
    en: "View on Wikimedia Commons",
    es: "Ver en Wikimedia Commons",
    nl: "Bekijk op Wikimedia Commons",
    pap: "Wak na Wikimedia Commons",
    pap_aw: "Wak na Wikimedia Commons",
  },
  translated_auto: {
    en: "Translated automatically · Source: Wikimedia Commons",
    es: "Traducido automáticamente · Fuente: Wikimedia Commons",
    nl: "Automatisch vertaald · Bron: Wikimedia Commons",
    pap: "Tradusí outomátikamente · Fuente: Wikimedia Commons",
    pap_aw: "Traduci automaticamente · Fuente: Wikimedia Commons",
  },
  back_all_photos: {
    en: "All photos", es: "Todas las fotos", nl: "Alle foto's",
    pap: "Tur foto", pap_aw: "Tur foto",
  },
  back_home: {
    en: "Home", es: "Inicio", nl: "Home", pap: "Kas", pap_aw: "Cas",
  },
  no_description: {
    en: "No description available.",
    es: "Sin descripción disponible.",
    nl: "Geen beschrijving beschikbaar.",
    pap: "No tin deskripshon disponibel.",
    pap_aw: "No tin descripcion disponibel.",
  },
};

export const HISTORY_ISLAND_LABELS = { aruba: "Aruba", curacao: "Curaçao" };
